import { useState, useCallback } from 'react';
import { adminAPI } from '@/services/api';

export const useEmailTest = () => {
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState<{ isOpen: boolean; success: boolean; message: string }>({
    isOpen: false,
    success: false,
    message: '',
  });

  const testEmail = useCallback(async (recipient: string) => {
    if (!recipient || !recipient.includes('@')) {
      setTestResult({
        isOpen: true,
        success: false,
        message: '올바른 이메일 주소를 입력해주세요.',
      });
      return;
    }

    setTesting(true);
    try {
      const result = await adminAPI.testEmail(recipient);
      setTestResult({
        isOpen: true,
        success: true,
        message: result.message || `테스트 메일이 ${recipient}로 전송되었습니다.`,
      });
      return true;
    } catch (error: any) {
      setTestResult({
        isOpen: true,
        success: false,
        message: error.response?.data?.detail || '테스트 메일 전송에 실패했습니다.',
      });
      return false;
    } finally {
      setTesting(false);
    }
  }, []);

  const testEmailTemplate = useCallback(async (templateId: string, recipient: string) => {
    if (!templateId || !recipient) {
      setTestResult({
        isOpen: true,
        success: false,
        message: '수신자 이메일을 입력해주세요.',
      });
      return false;
    }

    setTesting(true);
    try {
      const result = await adminAPI.testEmailTemplate(templateId, recipient);
      setTestResult({
        isOpen: true,
        success: true,
        message: result.message || `테스트 메일이 ${recipient}로 전송되었습니다.`,
      });
      return true;
    } catch (error: any) {
      setTestResult({
        isOpen: true,
        success: false,
        message: error.response?.data?.detail || '테스트 메일 전송에 실패했습니다.',
      });
      return false;
    } finally {
      setTesting(false);
    }
  }, []);

  return {
    testing,
    testResult,
    setTestResult,
    testEmail,
    testEmailTemplate,
  };
};

